import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getRandomId } from '../../utils/get-random-id';
import { UiControlValueAccessorDirective } from '../../basics/ui-control-value-accessor';
import { provideCustomCVA } from '../../basics/ui-custom-cva.provider';
import { ReactiveFormsModule } from '@angular/forms';
import { distinctUntilChanged, takeUntil } from 'rxjs';

@Component({
  selector: 'bosch-ui-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './bosch-ui-checkbox.component.html',
  styleUrls: ['./bosch-ui-checkbox.component.scss'],
  providers: [provideCustomCVA(BoschUiCheckboxComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiCheckboxComponent extends UiControlValueAccessorDirective<boolean | null> implements OnInit {
  @Input() set disabled(disabled: boolean) {
    this.setDisabledState(disabled);
  }
  @Input() set checked(checked: boolean) {
    this.control.setValue(checked, { emitEvent: false });
  }
  @Output() checkboxChange: EventEmitter<boolean | null> = new EventEmitter<boolean | null>(true);
  readonly id: string = getRandomId('checkbox');

  override ngOnInit(): void {
    super.ngOnInit();

    this.control.valueChanges
      .pipe(takeUntil(this.unsubscribe$), distinctUntilChanged())
      .subscribe((value: boolean | null) => {
        this.onChange(value);
        this.checkboxChange.emit(value);
      });
  }
}
